export const SET_EMAIL_LIST = "SET_EMAIL_LIST";